var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center py-11",style:(_vm.componentStyle)},[_c('v-container',[_c('h1',{staticClass:"PageBreak__header"},[_vm._t("header")],2),_c('div',{staticClass:"PageBreak__body mt-5"},[_vm._t("body")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }